import React, { useLayoutEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router';

import { CHANNEL_LIST_PATH } from '../../constants/routePath';

import * as commonSelectors from '../../redux/selectors/common';

type Props = {
  children: React.ReactNode;
};

function ChannelExistsValidation({ children }: Props) {
  const navigate = useNavigate();
  const params = useParams();
  const channels = useSelector(commonSelectors.channelsSelector);

  const targetChannel = channels.some((channel) => channel.id === +params.channel!);

  useLayoutEffect(() => {
    if (!targetChannel) {
      navigate(CHANNEL_LIST_PATH, { replace: true });
    }
  }, [params.channel, targetChannel, channels]);

  return targetChannel ? children : null;
}

export default ChannelExistsValidation;
